/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Still_Owl_PantInputs */

const en_rosy_still_owl_pant = /** @type {(inputs: Rosy_Still_Owl_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_rosy_still_owl_pant = /** @type {(inputs: Rosy_Still_Owl_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Rosy_Still_Owl_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_still_owl_pant = /** @type {((inputs?: Rosy_Still_Owl_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Still_Owl_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_still_owl_pant(inputs)
	return de_rosy_still_owl_pant(inputs)
});